// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35c5e086","453":"c9f1742f","455":"67ee94f8"}[chunkId] + ".chunk.js";
};